webpackJsonp([108372756028961],{

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(7);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _BannerLanding = __webpack_require__(9);
	
	var _BannerLanding2 = _interopRequireDefault(_BannerLanding);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import { Grid, Row, Col } from 'react-flexbox-grid';
	
	var pageTitle = "Pack site vitrine";
	var pageContent = ["Contenu de la prestation pour la création d'un site vitrine", "avec Wordpress ou un développement spécifique"];
	
	var Generic = function Generic(props) {
		return _react2.default.createElement(
			'div',
			{ style: props.transition && props.transition.style },
			_react2.default.createElement(
				_reactHelmet2.default,
				null,
				_react2.default.createElement(
					'title',
					null,
					'Web2alpes - ',
					pageTitle
				),
				_react2.default.createElement('meta', { name: 'description', content: 'Actions r\xE9alis\xE9es pour la cr\xE9ation d\'un site vitrine' }),
				_react2.default.createElement('meta', { name: 'language', content: 'fr-FR' }),
				_react2.default.createElement('meta', { 'http-equiv': 'content-type', content: 'text/html; charset=UTF-8' }),
				_react2.default.createElement('meta', { 'http-equiv': 'content-language', content: 'fr-FR' })
			),
			_react2.default.createElement(_BannerLanding2.default, { title: pageTitle, content: pageContent, particles: 'cms', color: 'style-logo-lg' }),
			_react2.default.createElement(
				'div',
				{ id: 'main', className: 'alt' },
				_react2.default.createElement(
					'section',
					{ id: 'support', className: 'tiles' },
					_react2.default.createElement(
						'article',
						{ className: 'full-medium' },
						_react2.default.createElement(
							'div',
							{ className: 'inner' },
							_react2.default.createElement(
								'header',
								{ className: 'major' },
								_react2.default.createElement(
									'h2',
									null,
									'Installation'
								)
							),
							_react2.default.createElement(
								'ul',
								{ className: 'snow' },
								_react2.default.createElement(
									'li',
									null,
									'Mise en place d\u2019une site Internet utilisant Wordpress (4.9) ou le framework React si c\'est un d\xE9veloppement personnalis\xE9,'
								),
								_react2.default.createElement(
									'li',
									null,
									'Recherche de l\'h\xE9bergeur et du registrar le plus adapt\xE9 aux besoins,'
								),
								_react2.default.createElement(
									'li',
									null,
									'Inscription, activation de l\u2019h\xE9bergement et du nom de domaine, installation site pilote vers version production,'
								),
								_react2.default.createElement(
									'li',
									null,
									'Optimisation du syst\xE8me de cache et minification du contenu de la boutique afin d\'am\xE9liorer grandement les performances,'
								),
								_react2.default.createElement(
									'li',
									null,
									'Int\xE9gration d\u2019un certificat HTTPS pour s\xE9curiser le site Internet,'
								),
								_react2.default.createElement(
									'li',
									null,
									'Mise en place de la sauvegarde du site Internet'
								)
							)
						)
					),
					_react2.default.createElement(
						'article',
						{ className: 'full-medium' },
						_react2.default.createElement(
							'div',
							{ className: 'inner' },
							_react2.default.createElement(
								'header',
								{ className: 'major' },
								_react2.default.createElement(
									'h2',
									null,
									'Accompagnement'
								)
							),
							_react2.default.createElement(
								'ul',
								{ className: 'snow' },
								_react2.default.createElement(
									'li',
									null,
									'Mise en place des pages : accueil, mentions l\xE9gales, formulaire de contact et \xE0 propos,'
								),
								_react2.default.createElement(
									'li',
									null,
									'Cr\xE9ation des diff\xE9rents comptes utilisateurs pour l\'exploitation du site Internet et du blog,'
								),
								_react2.default.createElement(
									'li',
									null,
									'R\xE9daction documentation (informations compl\xE8tes site, comptes, h\xE9bergement)),'
								),
								_react2.default.createElement(
									'li',
									null,
									'Formation \xE0 distance ou sur site \xE0 la gestion d\'un blog ou de la modification du contenu des pages'
								)
							)
						)
					),
					_react2.default.createElement(
						'article',
						{ className: 'full-medium' },
						_react2.default.createElement(
							'div',
							{ className: 'inner' },
							_react2.default.createElement(
								'header',
								{ className: 'major' },
								_react2.default.createElement(
									'h2',
									null,
									'Referencement'
								)
							),
							_react2.default.createElement(
								'ul',
								{ className: 'snow' },
								_react2.default.createElement(
									'li',
									null,
									'Int\xE9gration d\u2019un module SEO pour l\u2019optimisation du r\xE9f\xE9rencement naturel pour Wordpress,'
								),
								_react2.default.createElement(
									'li',
									null,
									'Mise en place de Google Analytics pour suivre votre r\xE9f\xE9rencement,'
								),
								_react2.default.createElement(
									'li',
									null,
									'Int\xE9gration du fichier sitemap XML pour faciliter l\u2019indexation des moteurs de recherches,'
								),
								_react2.default.createElement(
									'li',
									null,
									'Int\xE9gration du plan du site pour limiter les niveaux de profondeur des pages,'
								)
							)
						)
					),
					_react2.default.createElement(
						'article',
						{ className: 'full-medium' },
						_react2.default.createElement(
							'div',
							{ className: 'inner' },
							_react2.default.createElement(
								'header',
								{ className: 'major' },
								_react2.default.createElement(
									'h2',
									null,
									'Configuration'
								)
							),
							_react2.default.createElement(
								'ul',
								{ className: 'snow' },
								_react2.default.createElement(
									'li',
									null,
									'Personnalisation du th\xE8me en fonction de votre identit\xE9 visuelle et de vos attentes,'
								),
								_react2.default.createElement(
									'li',
									null,
									'Int\xE9gration de votre logo \xE0 votre site,'
								),
								_react2.default.createElement(
									'li',
									null,
									'Int\xE9gration de vos diff\xE9rents visuels en page d\u2019accueil,'
								),
								_react2.default.createElement(
									'li',
									null,
									'Int\xE9gration de fonctionnalit\xE9s des acc\xE8s aux r\xE9seau sociaux\xA0: Facebook, Google+...,'
								),
								_react2.default.createElement(
									'li',
									null,
									'Int\xE9gration d\u2019un bandeau d\u2019information sur l\u2019utilisation des cookies,'
								)
							)
						)
					)
				)
			)
		);
	};
	
	exports.default = Generic;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-pack-site-vitrine-js-dc0f5beb59ec498ea7be.js